import React from "react";
import { Checkbox, CheckboxGroup } from "@salt-ds/core";

interface CheckboxOption {
  label: string;
  value: string;
  className: string;
}

interface CheckBoxGroupProps {
  options: CheckboxOption[];
  checkedValues: string[];
  onChange: (values: string[]) => void;
  className?: string;
}

const CheckBoxGroupComponent: React.FC<CheckBoxGroupProps> = ({ ...props }) => {
  return (
    <CheckboxGroup
      onChange={props.onChange}
      checkedValues={props.checkedValues}
    >
      {props.options?.map((option: any) => (
        <div key={option.value}>
          <Checkbox label={option.label} value={option.value} />
        </div>
      ))}
    </CheckboxGroup>
  );
};
export default CheckBoxGroupComponent;
